"use client";

import React, { useState } from "react";
import styles from "@/styles/move-brasil.module.scss";

interface BannerImageProps {
	src: string;
	alt: string;
	className?: string;
	fallbackClassName?: string;
}

export const BannerImage: React.FC<BannerImageProps> = ({
	src,
	alt,
	className,
	fallbackClassName,
}) => {
	const [hasError, setHasError] = useState(false);

	if (hasError) {
		return (
			<div
				className={`${styles.imageFallback} ${fallbackClassName ?? ""} ${className ?? ""}`}
				role="img"
				aria-label={alt}
			/>
		);
	}

	return (
		<img
			src={src}
			alt={alt}
			className={className}
			onError={() => setHasError(true)}
		/>
	);
};
